export const createAttachment = ({ fileUrl, rootType, }) => {
    const medium = rootType.toUpperCase();
    return {
        medium,
        uri: fileUrl,
    };
};
